import * as React from "react";

export function usePaginatedFetch({
  enabled = true,
  auto = true,
  initialPage = 1,
  pageSize = 20,
  fetcher,
}) {
  const [page, setPage] = React.useState(initialPage);
  const [rows, setRows] = React.useState([]);
  const [totalPages, setTotalPages] = React.useState(1);
  const [selected, setSelected] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const fetchNow = React.useCallback(async () => {
    if (!enabled) return;

    setLoading(true);
    setError(null);
    try {
      const payload = await fetcher(page, pageSize);
      setRows(payload.data ?? []);
      setTotalPages(payload.pagination?.totalPages ?? 1);
    } catch (e) {
      setRows([]);
      setTotalPages(1);
      setError(e?.message ?? "Error al cargar datos");
    } finally {
      setLoading(false);
    }
  }, [enabled, fetcher, page, pageSize]);

  React.useEffect(() => {
    if (!enabled) return;
    if (!auto) return;
    fetchNow();
  }, [enabled, auto, fetchNow]);

  const resetPage = React.useCallback(() => setPage(1), []);

  return {
    page,
    pageSize,
    rows,
    totalPages,
    selected,
    loading,
    error,
    setPage,
    setRows,
    setTotalPages,
    setSelected,
    setError,
    resetPage,
    fetchNow, 
  };
}
